import { Content } from '@prismicio/client';
import {
  CtaImageMultipleTextProps,
  ICtaImageMultipleText,
  IItem,
} from './types';
import { FilledLinkToWebField } from '@prismicio/client';

export const mapCtaImageMultipleText = ({
  prismicContent,
}: {
  prismicContent: CtaImageMultipleTextProps['slice'];
}): ICtaImageMultipleText => {
  const items: IItem[] = prismicContent.items.map(
    (prismicItem: Content.CtaImageMultipleTextSliceDefaultItem) => {
      return {
        ...prismicItem,
        whiteBackground: prismicItem.white_background,
      };
    },
  );

  const {
    image: { url: image, alt },
    title_leafs_colors: titleLeafsColors,
    button_label: buttonLabel,
    internal_link: internalLink,
    external_link: externalLink,
  } = prismicContent.primary;

  const ctaImageMultipleText: ICtaImageMultipleText = {
    ...prismicContent.primary,
    image: image as string,
    alt: alt as string,
    buttonLabel: buttonLabel as string,
    titleLeafsColors: titleLeafsColors as string,
    link: internalLink || (externalLink as FilledLinkToWebField)!.url,
    items,
  };

  return ctaImageMultipleText;
};
